<template>
  <Modal class="banner-app__wrapper" v-show="isModal" @close="close">
    <div class="banner-app__header">
      <div class="banner-app__header__icon-close" @click="close()">
        <Icon icon="close" color="#9999A9" />
      </div>
    </div>

    <div class="banner-app__body banner-app__desktop">
      <img v-if="qrCodeUrl" :src="qrCodeUrl" class="banner-app__image" alt="" />
      <Icon v-else icon="app-qr-code" class="banner-app__image" />

      <div class="banner-app__title font-h2">Приложение YouTravel.me</div>

      <div class="banner-app__text">
        Наведите камеру на QR-код, чтобы установить приложение
      </div>
    </div>

    <div class="banner-app__body banner-app__mobile">
      <Icon icon="app-top-menu" class="banner-app__image" />

      <div class="banner-app__title font-h2">С приложением удобнее</div>

      <div class="banner-app__text">
        Проще управлять бронированиямии копить бонусы
      </div>

      <Button
        tag="a"
        class="banner-app__btn"
        color="violet"
        text="Открыть приложение"
        onclick="fakeWindow.open('/download-app')"
        @click="openAppBtnHandler"
      />

      <Button
        tag="a"
        class="banner-app__btn-cancel"
        color="white"
        text="Спасибо, не нужно"
        @click="close"
      />
    </div>
  </Modal>
</template>

<script>
import { defineComponent, ref } from "vue";
import { ytEvents } from "@/plugins/analytics";
import Icon from "@/components/icons/index.vue";
import Modal from "@/components/ui-kit/modal/index.vue";
import Button from "@/components/ui-kit/button/index.vue";

export default defineComponent({
  props: {
    qrCodeUrl: {
      type: String,
      default: "",
    },
  },
  components: {
    Icon,
    Modal,
    Button,
  },
  setup() {
    const isModal = ref(false);

    function open() {
      isModal.value = true;
    }

    function close() {
      ytEvents.track("Download App popup", "Click Close banner");
      isModal.value = false;
    }

    function openAppBtnHandler(){
      ytEvents.track("Download App popup", "Click Open App");
    }

    return {
      open,
      close,
      isModal,
      openAppBtnHandler,
    };
  },
});
</script>

<style lang="scss">
.banner-app {
  &__wrapper .custom-modal {
    width: 440px !important;
    position: relative !important;

    @include mixin.size-md {
      width: 100% !important;
      margin: auto 10px 10px 10px !important;
    }
  }

  @include am.wrapper();

  &__header {
    width: 100%;
    display: flex;
    padding: 10px;
    position: absolute;
    justify-content: flex-end;
    box-sizing: border-box;
    z-index: 10;

    &__icon {
      &-close {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        height: 32px;
        width: 32px;

        &:hover >>> path {
          stroke: var.$text-dark;
        }
      }
    }
  }

  &__image {
    display: block;
    margin: 0 auto;
    width: 100%;
    max-width: 200px;

    @include mixin.size-md {
      max-width: 58px;
      margin: 60px auto 0 auto;
    }
  }

  &__body {
    @include am.body();

    padding: 32px;
    text-align: center;
  }

  &__desktop {
    display: flex;

    @include mixin.size-md {
      display: none;
    }
  }

  &__mobile {
    display: none;

    @include mixin.size-md {
      display: flex;
    }
  }

  &__title {
    padding: 0;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 0;
    line-height: 22px;
  }

  &__text {
    font-size: 14px;
    margin-top: 12px;
    line-height: 20px;
    font-weight: normal;
    color: var.$neutral-500;
  }

  &__btn {
    margin-top: 40px;
  }

  &__btn-cancel {
    margin-top: 10px;
  }
}
</style>
